export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 60,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: '模板类型',
    field: 'v_templateType',
    minWidth: 130,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    editRender: { enabled: true },
    slots: { edit: 'templateType' },
  },
  {
    title: '渠道模板',
    field: 'templateName',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    editRender: { enabled: true },
    slots: { edit: 'templateName' },
  },
]
